import styled from '@emotion/styled';

export const SContainer = styled.div`
  background-color: white;
  padding: 16px 16px 24px;
  display: flex;
  justify-content: space-between;
`;
